import React from "react";
import { Box, Typography } from "@mui/material";

const FooterSection = ({ footerImage, publicData, IMAGE_BASE_URL }) => {
  console.log("👣 FooterSection - footerImage:", footerImage);
  console.log("👣 FooterSection - publicData:", publicData);

  const hasFooterImage = footerImage && footerImage.trim() !== "";
  const hasPhone = publicData?.phone && publicData.phone.trim() !== "";
  const hasAddress = publicData?.address && publicData.address.trim() !== "";

  return (
    <Box
      sx={{
        width: "100%",
        mt: { xs: 2, sm: 3, md: 4 },
        bgcolor: "#fffbe6",
        borderTop: "2px solid #ffe0b2",
      }}
    >
      {/* Footer Image */}
      {hasFooterImage && (
        <Box
          sx={{
            width: "100%",
            position: "relative",
            bgcolor: "#f5f5f5",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            component="img"
            src={`${IMAGE_BASE_URL}${footerImage}`}
            alt="Footer"
            onLoad={() => console.log("✅ تم تحميل صورة الفوتر بنجاح")}
            onError={(e) => {
              console.error("❌ فشل تحميل صورة الفوتر");
              e.target.style.display = "none";
            }}
            sx={{
              width: "100%",
              height: "auto",
              display: "block",
              maxHeight: { xs: 180, sm: 250, md: 300 },
              objectFit: "contain",
              objectPosition: "center",
              bgcolor: "#f5f5f5",
            }}
          />
        </Box>
      )}

      {/* Footer Info */}
      <Box
        sx={{
          px: { xs: 2, sm: 3, md: 4 },
          py: { xs: 2, sm: 2.5, md: 3 },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 1, sm: 1.25 },
        }}
      >
        {hasPhone && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: { xs: 0.75, sm: 1 },
              flexWrap: "wrap",
              justifyContent: "center",
              bgcolor: "#fff",
              px: { xs: 2, sm: 3 },
              py: { xs: 1, sm: 1.25 },
              borderRadius: { xs: 2, sm: 2.5 },
              boxShadow: "0 2px 8px rgba(255, 179, 0, 0.1)",
              border: "1px solid #ffe0b2",
            }}
          >
            <Typography
              component="span"
              sx={{
                fontSize: { xs: 18, sm: 20 },
              }}
            >
              📞
            </Typography>
            <Typography
              sx={{
                color: "#333",
                fontSize: { xs: 13, sm: 14, md: 15 },
                fontWeight: 600,
                textAlign: "center",
                direction: "ltr",
                letterSpacing: 0.5,
              }}
            >
              {publicData.phone}
            </Typography>
          </Box>
        )}

        {hasAddress && (
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: { xs: 0.75, sm: 1 },
              maxWidth: { xs: "100%", sm: "85%", md: "75%" },
              justifyContent: "center",
              bgcolor: "#fff",
              px: { xs: 2, sm: 3 },
              py: { xs: 1, sm: 1.25 },
              borderRadius: { xs: 2, sm: 2.5 },
              boxShadow: "0 2px 8px rgba(255, 179, 0, 0.1)",
              border: "1px solid #ffe0b2",
            }}
          >
            <Typography
              component="span"
              sx={{
                fontSize: { xs: 18, sm: 20 },
                flexShrink: 0,
                mt: 0.25,
              }}
            >
              📍
            </Typography>
            <Typography
              sx={{
                color: "#333",
                fontSize: { xs: 13, sm: 14, md: 15 },
                fontWeight: 500,
                textAlign: "center",
                lineHeight: 1.7,
                wordBreak: "break-word",
              }}
            >
              {publicData.address}
            </Typography>
          </Box>
        )}

        {/* Divider */}
        {(hasPhone || hasAddress) && (
          <Box
            sx={{
              width: { xs: "70%", sm: "50%", md: "40%" },
              height: 2,
              bgcolor: "#ffe0b2",
              borderRadius: 1,
              my: { xs: 0.75, sm: 1 },
            }}
          />
        )}

        {/* Copyright */}
        <Typography
          sx={{
            color: "#999",
            fontSize: { xs: 11, sm: 12, md: 13 },
            fontWeight: 500,
            textAlign: "center",
            letterSpacing: 0.5,
          }}
        >
          جميع الحقوق محفوظة ريستوكاش © {new Date().getFullYear()}
        </Typography>
      </Box>
    </Box>
  );
};

export default FooterSection;
